<div class="header" trans><mat-icon svgIcon="people" class="size-18 align-middle"></mat-icon> Permissions</div>

<form class="body many-inputs" (submit)="saveSettings()">
    //
</form>